export default "__VITE_ASSET__cRQLeylV__"